import { Box, Button, Typography } from '@material-ui/core'
import { GridFooter, GridFooterContainer } from '@mui/x-data-grid'
import React from 'react'
import { Plus } from 'react-feather'
import { useTranslation } from 'react-i18next'
import { theme } from '../../../../theme'

type Props = {
  onDeviceCreateStart: () => void
  totalAirFlowLabel: string
}

export function VentilationFormGridFooter({
  onDeviceCreateStart,
  totalAirFlowLabel,
}: Props): React.ReactElement {
  const { t } = useTranslation()

  return (
    <GridFooterContainer>
      {/* <Box display="flex" width="100%" justifyContent="space-between"> */}
      <Box display="flex" flexGrow={1} gridGap={theme.spacing(1)}>
        <Box marginLeft="10px">
          <Button
            variant="contained"
            size="small"
            color="primary"
            startIcon={<Plus />}
            onClick={onDeviceCreateStart}
          >
            {t('energySystem.parameters.ventilation.dialog.addDevice')}
          </Button>
        </Box>
        <Box flexGrow={1} />
        <Box marginTop="auto" marginRight="10px" flexDirection="row-reserve">
          <Typography
            variant="body2"
            align="center"
            style={{ fontWeight: 'bold' }}
          >
            {totalAirFlowLabel}
          </Typography>
        </Box>
        {/* <GridFooter /> */}
      </Box>
    </GridFooterContainer>
  )
}
